import { useEffect, useState } from 'react';

import { InputNumber, Select } from 'antd';

import SelectInputWrapper from '@/components/style';

const limitDecimalsP = (v) => {
  const reg = /^\d+$/;
  return reg.test(v) ? v : '';
};

export default function InputSelect({
  productRecord,
  placeholder,
  value,
  setValue,
  productUnit,
  setProductUnit,
  defaultValue,
  inputRef,
  onPressEnter,
  disabled,
  inputWidth,
}) {
  const [unit, setUnit] = useState(productUnit ? productUnit : productRecord?.productUnit);

  useEffect(() => {
    setProductUnit?.(unit);
  }, [unit]);

  const options = [
    {
      value: productRecord?.productUnit,
      label: <span>{productRecord?.productUnit}</span>,
    },
    {
      value: productRecord?.productMinEncapsulationUnit,
      label: <span>{productRecord?.productMinEncapsulationUnit}</span>,
    },
  ];
  const overseaOptions = [
    {
      value: productRecord?.unit,
      label: <span>{productRecord?.unit}</span>,
    },
  ];

  const selectAfter = (
    <Select
      size={'large'}
      value={unit}
      defaultValue={unit}
      className="w-[60px]"
      options={productRecord?.isOversea ? overseaOptions : options}
      onChange={(val) => setUnit(val)}
      disabled={disabled}
    ></Select>
  );

  return (
    <SelectInputWrapper>
      <InputNumber
        defaultValue={defaultValue}
        controls={false}
        value={value}
        size={'large'}
        placeholder={placeholder}
        addonAfter={selectAfter}
        disabled={disabled}
        min={1}
        onPressEnter={onPressEnter}
        ref={inputRef}
        formatter={limitDecimalsP}
        onChange={setValue}
        maxLength={8}
        className={`w-[${inputWidth}]`}
      />
    </SelectInputWrapper>
  );
}
